/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * GetDocument.Insider
 * OpenAPI spec version: 1.0.0
 */
import {
    HttpClient,
    HttpHeaders,
    HttpResponse as AngularHttpResponse,
} from '@angular/common/http';
import type { HttpContext, HttpEvent, HttpParams } from '@angular/common/http';

import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import type {
    SearchAccessibleDocumentsRequest,
    SearchAccessibleDocumentsResponse,
} from '../core-models';

interface HttpClientOptions {
    readonly headers?: HttpHeaders | Record<string, string | string[]>;
    readonly context?: HttpContext;
    readonly params?:
        | HttpParams
        | Record<
              string,
              string | number | boolean | Array<string | number | boolean>
          >;
    readonly reportProgress?: boolean;
    readonly withCredentials?: boolean;
    readonly credentials?: RequestCredentials;
    readonly keepalive?: boolean;
    readonly priority?: RequestPriority;
    readonly cache?: RequestCache;
    readonly mode?: RequestMode;
    readonly redirect?: RequestRedirect;
    readonly referrer?: string;
    readonly integrity?: string;
    readonly referrerPolicy?: ReferrerPolicy;
    readonly transferCache?: { includeHeaders?: string[] } | boolean;
    readonly timeout?: number;
}

type HttpClientBodyOptions = HttpClientOptions & {
    readonly observe?: 'body';
};

type HttpClientEventOptions = HttpClientOptions & {
    readonly observe: 'events';
};

type HttpClientResponseOptions = HttpClientOptions & {
    readonly observe: 'response';
};

type HttpClientObserveOptions = HttpClientOptions & {
    readonly observe?: 'body' | 'events' | 'response';
};

@Injectable({ providedIn: 'root' })
export class DocumentsApiService {
    private readonly http = inject(HttpClient);
    /**
     * Searches an explicit accessible-building set, then applies current Core document permissions and visibility. Pages contain at most PerPage index candidates and can be short or empty after authorization. HasMore refers to another candidate page, not an authorized result count. No signed links are generated. The index is eventually consistent; pages are not a snapshot. SearchLimitReached requires refining the query.
     * @summary Search documents across accessible buildings
     */
    searchDocuments<TData = SearchAccessibleDocumentsResponse>(
        searchAccessibleDocumentsRequest: SearchAccessibleDocumentsRequest,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    searchDocuments<TData = SearchAccessibleDocumentsResponse>(
        searchAccessibleDocumentsRequest: SearchAccessibleDocumentsRequest,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    searchDocuments<TData = SearchAccessibleDocumentsResponse>(
        searchAccessibleDocumentsRequest: SearchAccessibleDocumentsRequest,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    searchDocuments<TData = SearchAccessibleDocumentsResponse>(
        searchAccessibleDocumentsRequest: SearchAccessibleDocumentsRequest,
        options?: HttpClientObserveOptions
    ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
        if (options?.observe === 'events') {
            return this.http.post<TData>(
                `/@core/api/documents/search`,
                searchAccessibleDocumentsRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.post<TData>(
                `/@core/api/documents/search`,
                searchAccessibleDocumentsRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.post<TData>(
            `/@core/api/documents/search`,
            searchAccessibleDocumentsRequest,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
}
